<template>
  <div ref="SubSaleCar"
       class="SubSaleCar">
    <HeaderTop />
    <div class="car-arrow">
      <div class="w">
        <el-breadcrumb separator-class="el-icon-arrow-right arrow">
          <el-breadcrumb-item :to="{ path: '/' }">易手車</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '/salecar' }">在售車源</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '/salecar' }">{{cars.brandName}}</el-breadcrumb-item>
          <el-breadcrumb-item>{{cars.modelName}}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
    </div>
    <div class="w container">
      <div class="container-detail">
        <!-- 轮播 -->
        <div class="pc-slide">
          <div class="swiper-container swiper-view"
               id="view">
            <div class="swiper-wrapper ovef">
              <div class="swiper-slide swiper-no-swiping"
                   v-for="item in imgs"
                   :key="item.id">
                <img :src="item.imageName" />
              </div>
            </div>
          </div>
          <div class="swiper-preview-box">
            <div class="swiper-button-prev button-left"
                 :style="{height:imgHeight +'px'}"><i class="iconfont icon-you"></i></div>
            <div class="swiper-container swiper-preview"
                 :style="{height:imgHeight +'px'}"
                 id="preview">
              <div class="swiper-wrapper">
                <div class="swiper-slide"
                     :style="{height:imgHeight +'px'}"
                     v-for="item in imgs"
                     :key="item.id">
                  <img ref="imgHeight"
                       :src="item.imageName"
                       @load="imgLoad" />
                </div>
              </div>
            </div>
            <div class="swiper-button-next button-right"
                 :style="{height:imgHeight +'px'}"><i class="iconfont icon-right"></i></div>
          </div>
        </div>
        <div class="car-detail">
          <div class="car-title">
            <h6>{{cars.title}}<span v-if="cars.status === 3">(已售)</span></h6>
            <div class="tags">
              <em :class="item.class"
                  :hidden="type.length == 0 ? true : false"
                  v-for="(item, index) in type"
                  :key="index">{{ item.typeName }}</em>
              <!-- <em class="s-bx">免费检测</em> -->
              <!-- <em class="s-fqgc">分期购车</em> -->
            </div>
            <div class="car-price">
              <div class="car-price-total">
                <strong>{{ cars.price }}萬</strong>
              </div>
              <div class="car-price-ratio">
                新車價：¥{{ cars.priceNew }}萬
              </div>
            </div>
            <div class="carr-attrs">
              <dl>
                <dt>上牌時間</dt>
                <dd>{{ cars.licensDate }}</dd>
              </dl>
              <dl>
                <dt>里程</dt>
                <dd>{{ cars.mileage | MoneyFormat }}公里</dd>
              </dl>
              <dl>
                <dt>排量/變速箱</dt>
                <dd>{{ cars.outputVolume }}/{{ cars.gearBox }}</dd>
              </dl>
              <dl>
                <dt>所在地</dt>
                <dd>{{ cars.location }}</dd>
              </dl>
              <dl>
                <dt>排放標準</dt>
                <dd>{{ cars.emissionStandard }}</dd>
              </dl>
            </div>
            <div class="car-detail-btn">
              <a href="javascript:;"
                 class="btn-line"
                 @click="clickMy"><span class="icon-msg"></span>線上諮詢</a>
              <a href="javascript:;"
                 class="btn-line"
                 @click="clickMyPo"><span class="icon-msg"></span>點擊撥打電話諮詢</a>
            </div>
            <div>
              <p></p>
            </div>
          </div>
        </div>
      </div>
      <div class="container-security">
        <ul>
          <li><i class="iconfont icon-tuihuanxiu"></i><span>免費專業檢測</span></li>
          <li><i class="iconfont icon-baozhang"></i><span>一年不限里程</br>原廠延長質保</span></li>
          <li><i class="iconfont icon-tiantuihuan"></i><span>7天可退換</span></li>
        </ul>
      </div>
      <div ref="containerDetailTabnav"
           class="container-detail-tabnav">
        <a ref="aa"
           class="cur"
           href="javascript:;">車輛資訊</a>
        <a ref="ab"
           href="javascript:;">車輛圖片</a>
        <a ref="ac"
           href="javascript:;">品薦認證二手車</a>
      </div>
      <div :hidden="tabnavtf"
           style="background: #fff"
           class="container-detail-tabnav"></div>
      <div ref="cba"
           class="container-box">
        <div class="title">車輛資訊</div>
        <div class="box">
          <div class="box-left">
            <ul>
              <li><span>{{ cars.emissionStandard }}</span>排放標準</li>
              <li><span>{{ cars.mileage | MoneyFormat }}公里</span>里程數</li>
              <li><span>{{ cars.carType }}</span>車輛類型</li>
              <li><span>{{ cars.licensDate }}</span>上牌時間</li>
              <li><span>{{ cars.yearInspectDate }}</span>年檢到期</li>
              <li><span>{{ cars.insureDate }}</span>保險到期</li>
              <li><span>{{ cars.maintainInfo }}</span>保養情况</li>
            </ul>
          </div>
          <div class="box-right">
            <ul>
              <li><span>{{ cars.carLength }}/{{ cars.carWidth }}/{{ cars.carHeight }}</span>長寬高(mm)</li>
              <li><span>{{ cars.wheelbase }}</span>軸距(mm)</li>
              <li><span>{{ cars.engine }}</span>發動機</li>
              <li><span>{{ cars.driveType }}</span>驅動管道</li>
              <li><span>{{ cars.gearBox }}</span>變速箱</li>
              <li><span>{{ cars.outputVolume }}</span>排量</li>
              <li><span>{{ cars.oil }}</span>油耗</li>
            </ul>
          </div>
        </div>
      </div>
      <div ref="cbb"
           class="container-box">
        <div class="title">車輛圖片</div>
        <div class="box">
          <div class="box-picture">
            <ul>
              <li v-for="(item, index) in imgs"
                  :style="{height:imgHeightCar +'px'}"
                  :key="index">
                <img ref="imgHeightCar"
                     :src="item.imageName"
                     @load="imgLoad">
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div ref="cbc"
           class="container-box">
        <div class="title">品薦認證二手車</div>
        <div class="box">
          <div class="box-info"
               v-html="cars.describe">
            <!-- <p>{{ cars.describe }}</p> -->
          </div>
        </div>
      </div>
      <FooterAbout />
    </div>
    <Copy />
    <div ref="cBox"
         class="cBox">
      <div class="box">
        <p><img v-if="position == 1"
               src="../../images/wxwx-gz.jpg" /><img v-if="position == 2"
               src="../../images/wxwx.jpg" /></p>
        <h4>掃二維碼線上資訊</h4>
      </div>
      <div ref="boxbg"
           @click.self="clickMyNo"
           class="box-bg">

      </div>
    </div>
    <div ref="cBoxPo"
         class="cBoxPo">
      <div class="box">
        <h4>联系电话</h4>
        <p>{{position == 1 ? '020-85292590' : '15118088395'}}</p>
      </div>
      <div ref="boxbg"
           @click.self="clickMyNoPo"
           class="box-bg">

      </div>
    </div>
  </div>
</template>

<script>
import { reqCarDetail, reqAllFP, BASE_URL } from '../../api/'
import PubSub from 'pubsub-js'
import HeaderTop from '../../components/HeaderTop.vue'
import FooterAbout from '../../components/FooterAbout.vue'
import Copy from '../../components/Copy.vue'
import Cookies from 'js-cookie'
import Swiper from 'swiper'
import '../../js/NumFormat.js'
// import { MessageBox } from 'mint-ui'

export default {
  name: 'SubSaleCar',
  data () {
    return {
      position: Cookies.get('position') || 2,
      url: BASE_URL + '/usedcar/upload/usedCar/',
      imgHeight: '',
      imgHeightCar: '',
      cdtHeight: '', //获取车辆信息、车辆图片高度
      tabnavtf: '',
      cars: {},
      imgs: [],
      type: []
    }
  },
  created () {
    let that = this
    let fpArray = []
    console.log('id', this.$route.params.goodId)
    reqCarDetail(this.$route.params.goodId).then(res => {
      console.log('res', res)
      that.cars = res.data
      that.cars.licensDate = this.moment(that.cars.licensDate).format("YYYY-MM-DD")
      that.cars.yearInspectDate = this.moment(that.cars.yearInspectDate).format("YYYY-MM-DD")
      that.cars.insureDate = this.moment(that.cars.insureDate).format("YYYY-MM-DD")
      // that.cars.maintainInfo = this.moment(that.cars.maintainInfo).format("YYYY-MM-DD")
      // that.imgHeight = 40
      that.cars.favouredPolicy = that.cars.favouredPolicy.split(',')
      that.cars.favouredPolicy.forEach(item => {
        fpArray.push(+item)
      })
      that.cars.favouredPolicy = fpArray
      reqAllFP().then(resfp => {
        for (let i = 0; i < resfp.data.length; i++) {
          for (let j = 0; j < that.cars.favouredPolicy.length; j++) {
            if (that.cars.favouredPolicy[j] == resfp.data[i].id) {
              that.type.push({ id: resfp.data[i].id, typeName: resfp.data[i].policyName, class: 's-class' + resfp.data[i].id })
            }
          }
        }
        console.log(that.type)
      })
      if (that.cars.carImageList.length == 0) {
        that.imgs.push({ id: 1, imageName: 'http://www.dg-hyundai.com/UploadFile/pic/gzysc1/zanwu.gif' })
      } else {
        that.cars.carImageList.forEach(val => {
          that.imgs.push({ id: val.id, imageName: this.url + val.imageName })
        })
      }
      if (that.imgs.length > 0) {
        that.$nextTick(function () {
          that.bug()
          that.imgLoad()
          that.scroll()
          that.resize()
        })
      }
      console.log('this.cars', this.cars)
      console.log('this.imgs', this.imgs)
    })
  },
  methods: {
    clickMy () {
      // MessageBox('掃二維碼線上資訊', '<img src="'+ 'http://172.20.60.100:9192/usedcar/upload/usedCar/1557019098153_1.jpg' +'"/>>')
      this.$refs.cBox.classList.add('current')
    },
    clickMyNo () {
      this.$refs.cBox.classList.remove('current')
    },
    clickMyPo () {
      this.$refs.cBoxPo.classList.add('current')
    },
    clickMyNoPo () {
      this.$refs.cBoxPo.classList.remove('current')
    },
    getCar () {
      PubSub.publish('id', this.cars.id)
    },
    imgLoad () {
      console.log('this.$refs.imgHeight', this.$refs.imgHeight[0].height)
      if (this.$refs.imgHeight[0].height == 'undefined') {
        this.imgHeight = 60
        this.imgHeightCar = 300
      } else {
        this.imgHeight = this.$refs.imgHeight[0].height
        this.imgHeightCar = this.$refs.imgHeightCar[0].height
      }
    },
    bug () {
      // 小
      let preview = new Swiper('#preview', {
        slidesPerView: 4,
        watchSlidesVisibility: true, //防止不可点击
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        observer: true
      })
      // 大
      let view = new Swiper('#view', {
        thumbs: {
          swiper: preview
        }
      })
    },
    scroll () {
      const that = this
      const cdt = that.$refs.containerDetailTabnav
      const cba = that.$refs.cba
      const cbb = that.$refs.cbb
      const cbc = that.$refs.cbc
      setTimeout(() => {
        // console.log('document.documentElement.scrollTop', document.documentElement.scrollTop)
        // console.log('document.documentElement.scrollTop', document.body.scrollTop)
        // console.log('containerDetailTabnav', cdt)
        that.cdtHeight = cdt.offsetTop - 100

        window.addEventListener('scroll', function () {
          const scrollTop = document.documentElement.scrollTop || document.body.scrollTop
          console.log('scrollTop', scrollTop)
          console.log('cdtHeight', that.cdtHeight)

          if (scrollTop > that.cdtHeight) {
            //滚动条的高度，可以动态获取也可以写死
            //这里写要执行的操作
            cdt.classList.add("fix")
            // console.log(' cdt.classList',  cdt.classList)
            that.tabnavtf = false
            // console.log(that.cdtHeight)
          } else {
            cdt.classList.remove("fix")
            // console.log(' cdt.classList',  cdt.classList)
            that.tabnavtf = true
          }
          // console.log('tag', document.body.height )
          // console.log('tag', document.documentElement.height )
          // console.log('tag', that.$refs.SubSaleCar.scrollHeight )
          if (scrollTop > cbb.offsetTop && scrollTop < cbc.offsetTop) {
            that.$refs.aa.classList.remove("cur")
            that.$refs.ab.classList.add("cur")
            that.$refs.ac.classList.remove("cur")
            console.log('aaaaaaaaaaaaaaaaaaaaa')
            // console.log('cbc.offsetTop', cbc.offsetTop)
          } else if (scrollTop > cbc.offsetTop) {
            that.$refs.aa.classList.remove("cur")
            that.$refs.ab.classList.remove("cur")
            that.$refs.ac.classList.add("cur")
            console.log('bbbbbbbbbbbbbbbbbbbbbbb')
          } else {
            that.$refs.aa.classList.add("cur")
            that.$refs.ab.classList.remove("cur")
            that.$refs.ac.classList.remove("cur")
            console.log('ccccccccccccccccccc')
          }
        }, true)
      }, 1000)
    },
    resize () {
      const that = this
      window.addEventListener('resize', () => {
        if (that.$refs.imgHeight[0].height == 'undefined') {
          that.imgHeight = 60
          that.imgHeightCar = 300
        } else {
          that.imgHeight = that.$refs.imgHeight[0].height
          that.imgHeightCar = that.$refs.imgHeightCar[0].height
        }
        that.imgLoad()
      }, false)
    }
  },
  mounted () {
    this.getCar()
  },
  components: {
    HeaderTop,
    FooterAbout,
    Copy
  }
}
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
@import '../../../node_modules/swiper/dist/css/swiper.min.css';
@import '../../css-styl/mixins.styl';

.SubSaleCar >>> {
  .ql-size-small {
    font-size: 12px;
    line-height: 16px;
  }

  .ql-size-large {
    font-size: 18px;
    line-height: 22px;
  }

  .ql-size-huge {
    font-size: 30px;
    line-height: 40px;
  }
}

.SubSaleCar {
  .car-arrow, .container-detail, .container-security, .container-detail-tabnav, .container-box {
    font-family: Verdana, 'Microsoft Yahei', SimSun, 'Heiti SC', 'Droid sans';
  }

  .car-arrow {
    background: #f8f8f8;
    height: 44px;

    // 面包屑
    .el-breadcrumb {
      font-size: 14px;
      height: 44px;
      line-height: 44px;
      margin-left: 10px;

      .el-breadcrumb__inner a, .el-breadcrumb__inner.is-link {
        color: #686868;
      }

      .el-breadcrumb__inner a:hover, .el-breadcrumb__inner.is-link:hover {
        color: #af0426;
      }
    }
  }

  .container {
    margin-top: 20px;

    .container-detail {
      overflow: hidden;
      margin-bottom: 20px;

      // 轮播
      .pc-slide {
        width: 40%;
        float: left;

        .swiper-view {
          width: 100%;

          .swiper-slide {
            text-align: center;
            width: 100% !important;
            margin: 10px 0 10px 0 !important;

            img {
              width: 100%;
            }
          }
        }

        .swiper-preview-box {
          width: 100%;
          overflow: hidden;
        }

        .swiper-preview {
          width: 90%;
          float: left;

          .swiper-slide {
            width: 90%;
            text-align: center;

            img {
              width: 96%;
              cursor: pointer;
            }

            .swiper-wrapper {
              width: 90% !important;
            }

            .ovef {
              overflow: hidden;
            }
          }
        }

        .button-left, .button-right {
          position: static !important;
          float: left;
          width: 4%;
          margin-top: 0 !important;
          background-size: auto;
          background-image: none;
          color: #af0426;
          background: #efefef;
          display: flex;
          flex-direction: column;
          justify-content: center;

          i {
            font-size: 20px;
            font-weight: 600;
          }
        }

        .button-left {
          margin-right: 1%;
        }

        .button-right {
          margin-left: 1%;
        }
      }

      // .el-carousel
      // width 90%
      // margin 0 auto
      // .bannerImg
      // width 100%
      // // .el-carousel__indicators,
      // // .el-carousel__indicators--outside
      // //   display none !important
      // .imgClass
      // .el-carousel__indicators--outside button
      // height 2px
      // border-radius 10px
      // background-color #333
      .car-detail {
        width: 56%;
        color: #323232;
        float: left;
        padding-left: 4%;

        h6 {
          font-size: 24px;
          font-weight: 600;
        }

        .tags {
          font-family: Hiragino Sans GB, Microsoft Yahei UI, Microsoft Yahei, Segoe UI, Tahoma, SimSun, sans-serif;
          padding-top: 14px;

          em {
            font-style: normal;
            border: 1px solid #ff6402;
            font-size: 12px;
            color: #ff6402;
            line-height: 18px;
            padding: 0 3px;
            height: 20px;
            display: inline-block;
            border-radius: 2px;
            -moz-border-radius: 2px;
            -webkit-border-radius: 2px;
            margin-right: 4px;
          }

          .s-class1 {
            border: 1px solid #ff6402;
            color: #ff6402;
          }

          .s-class2 {
            border: 1px solid #7fc7e9;
            color: #7fc7e9;
          }

          .s-class3 {
            border: 1px solid #7bb07a;
            color: #7bb07a;
          }

          .s-class4 {
            border: 1px solid #4090FF;
            color: #4090FF;
          }

          .s-class5 {
            border: 1px solid #7940FF;
            color: #7940FF;
          }

          .s-class6 {
            border: 1px solid #DF40FF;
            color: #DF40FF;
          }

          .s-class7 {
            border: 1px solid #FFC340;
            color: #FFC340;
          }

          .s-class8 {
            border: 1px solid #FF4090;
            color: #FF4090;
          }

          .s-class9 {
            border: 1px solid #FF8040;
            color: #FF8040;
          }

          .s-class10 {
            border: 1px solid #2CAD40;
            color: #2CAD40;
          }

          .s-class11 {
            border: 1px solid #40D2FF;
            color: #40D2FF;
          }

          .s-class12 {
            border: 1px solid #39A29E;
            color: #39A29E;
          }

          .s-class13 {
            border: 1px solid #FF4040;
            color: #FF4040;
          }

          .s-class14 {
            border: 1px solid #6640FF;
            color: #6640FF;
          }

          .s-class15 {
            border: 1px solid #40FF5D;
            color: #40FF5D;
          }
        }
      }

      .car-price {
        padding-top: 30px;

        .car-price-total {
          strong {
            font-family: Hiragino Sans GB, Microsoft Yahei UI, Microsoft Yahei, Segoe UI, Tahoma, SimSun, sans-serif;
            font-size: 30px;
            color: #af0426;
            display: inline-block;
            font-weight: 600;

            &:after, &:before {
              display: inline-block;
              font-size: 24px;
              box-sizing: border-box;
            }

            &:after {
              content: '';
              margin-left: 6px;
            }

            &:before {
              content: '¥';
              margin-right: 6px;
            }
          }
        }

        .car-price-ratio {
          display: inline-block;
          padding-top: 8px;
          font-size: 14px;
          color: #999;
          line-height: 22px;
          letter-spacing: 0.2px;
        }
      }

      .carr-attrs {
        width: 100%;
        margin: 45px auto 0;
        overflow: hidden;

        dl {
          width: 20%;
          text-align: center;
          color: #323232;
          background: #f8f8f8;
          border-left: 1px solid #e6e6e6;
          float: left;
          padding: 10px 0;
          box-sizing: border-box;

          &:nth-of-type(1) {
            width: 28%;
            border-left: none;
          }

          &:nth-of-type(4), &:nth-of-type(5) {
            width: 16%;
          }

          dt {
            font-size: 12px;
            margin-bottom: 10px;
            display: block;
          }

          dd {
            font-size: 15px;
            font-weight: 600;
            display: block;
          }
        }
      }

      .car-detail-btn {
        margin-top: 40px;
        overflow: hidden;

        .btn-line {
          width: 30%;
          height: 50px;
          line-height: 50px;
          font-size: 21px;
          text-align: center;
          color: #fff;
          background: #000;
          float: left;
          margin-right: 30px;

          &:hover, &:focus {
            background: #c03;
            transition: background 0.2s;
            -moz-transition: background 0.2s;
            -webkit-transition: background 0.2s;
            -o-transition: background 0.2s;
          }

          &:nth-of-type(1) {
            background: #c03;

            &:hover, &:focus {
              background: #af0426;
              transition: background 0.2s;
              -moz-transition: background 0.2s;
              -webkit-transition: background 0.2s;
              -o-transition: background 0.2s;
            }
          }
        }
      }
    }

    .container-security {
      font-size: 14px;
      background: #f4f4f4;
      padding: 30px 0;
      overflow: hidden;

      ul {
        li {
          width: 33.33%;
          float: left;
          text-align: center;

          i {
            font-size: 52px;
            color: #434c53;
            vertical-align: middle;
            display: inline-block;
            margin-bottom: 3px;
          }

          span {
            font-size: 14px;
            vertical-align: middle;
            display: inline-block;
            margin-left: 10px;
          }
        }
      }
    }

    .container-detail-tabnav {
      font-size: 16px;
      height: 44px;
      line-height: 44px;
      background: #f4f4f4;
      margin-top: 30px;
      margin-bottom: 10px;
      overflow: hidden;

      &.fix {
        font-size: 17px;
        margin-top: 0;
        margin-bottom: 0;
        width: 100%;
        position: fixed;
        top: 0;
        left: 0;
        box-shadow: 0px 3px 6px #ccc;
        height: 66px;
        line-height: 66px;

        a {
          height: 66px;
        }
      }

      a {
        height: 44px;
        color: #383434;
        border-left: 1px solid #dbdbdb;
        border-right: 1px solid #dbdbdb;
        margin-right: -1px;
        padding: 0 26px;
        float: left;

        &.cur {
          background: #c03;
          color: #fff;
        }
      }
    }

    .container-box {
      color: #383434;
      overflow: hidden;

      .title {
        font-size: 22px;
        font-weight: 600;
        padding: 40px 0 20px;
        border-bottom: 1px solid #e5e5e5;
      }

      .box-left, .box-right {
        float: left;
        width: 50%;
        font-size: 14px;

        ul {
          padding: 4px 80px 0 0;

          li {
            height: 44px;
            line-height: 44px;
            border-bottom: 1px solid #e5e5e5;
            color: #848788;
            padding-left: 12px;

            span {
              float: right;
              color: #383434;
            }
          }
        }
      }

      .box-right {
        ul {
          padding: 4px 0 0 80px !important;
        }
      }

      .box-picture {
        margin-top: 20px;

        ul {
          width: 100%;
          overflow: hidden;

          li {
            float: left;
            width: 48%;
            height: auto;
            margin-bottom: 2%;
            padding-left: 1%;
            padding-right: 1%;
            box-sizing: border-box;

            // &:nth-last-child(1),
            // &:nth-last-child(2)
            // margin-bottom 0 !important
            img {
              width: 100%;
              height: auto;
              display: inline;
              vertical-align: top;
            }
          }
        }
      }

      .box-info {
        font-size: 14px;
        line-height: 18px;
        padding: 20px 30px;

        p {
          line-height: 20px;
          letter-spacing: 0.1px;
        }
      }
    }

    .container-box-top {
      margin-top: 88px !important;
    }
  }

  .cBox, .cBoxPo {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 990;
    display: none;
    opacity: 0;
    width: 100%;
    height: 100%;
    border-radius: 10px;
    transition: all 0.2s;

    &.current {
      opacity: 1;
      display: block;
    }

    .box {
      position: absolute;
      top: 50%;
      left: 50%;
      z-index: 992;
      font-size: 18px;
      width: 400px;
      // padding 60px 0
      margin-left: -200px;
      margin-top: -150px;
      text-align: center;
      border-radius: 6px;
      background: #fff;

      h4 {
        font-size: 24px;
        padding: 10px 0 20px;
      }

      p {
        padding: 20px 0 10px;
        display: block;

        img {
          width: 300px;
        }
      }
    }

    .box-bg {
      position: absolute;
      top: 0;
      left: 0;
      z-index: 991;
      width: 100%;
      height: 100%;
      background: rgba(0, 0, 0, 0.5);
    }
  }
}

@media screen and (min-width: 800px) and (max-width: 1000px) {
  .SubSaleCar .container .container-detail {
    .car-detail {
      .tags {
        padding-top: 10px;
      }

      .car-price {
        padding-top: 20px;
      }

      .carr-attrs {
        margin: 25px auto 0;
      }

      .car-detail-btn .btn-line {
        font-size: 18px;
      }
    }
  }
}

@media screen and (min-width: 797px) and (max-width: 900px) {
  .SubSaleCar .container .container-detail {
    .car-detail {
      .carr-attrs dl dd {
        font-size: 13px;
      }
    }

    .car-detail-btn {
      margin-top: 24px;

      .btn-line {
        font-size: 17px;
      }
    }
  }
}

@media screen and (min-width: 100px) and (max-width: 796px) {
  .SubSaleCar .container .container-detail {
    .pc-slide {
      width: 100%;
      float: none;
    }

    .car-detail {
      width: 100%;
      float: none;
      padding-left: 0;

      .car-title {
        padding: 30px;
      }
    }
  }
}

@media screen and (min-width: 100px) and (max-width: 700px) {
  .SubSaleCar .container .container-detail {
    .car-detail {
      .tags {
        padding-top: 10px;
      }

      .car-price {
        padding-top: 20px;
      }

      .carr-attrs {
        margin: 25px auto 0;
      }

      .car-detail-btn .btn-line {
        font-size: 16px;
      }
    }
  }
}

@media screen and (min-width: 100px) and (max-width: 560px) {
  .SubSaleCar {
    .cBox .box {
      width: 90%;
      margin-left: -45%;
      margin-top: -80%;
    }

    .container {
      .container-detail {
        .car-detail {
          .car-title {
            padding: 20px 0;

            h6 {
              padding: 0 20px;
            }

            .tags {
              padding: 6px 20px 0;
            }

            .car-price {
              padding: 14px 20px 0;
            }

            .carr-attrs {
              margin: 18px auto 0;
              box-shadow: box-shadow;

              dl dd {
                font-size: 12px;
              }
            }

            .car-detail-btn {
              margin-top: 20px;
              display: flex;
              /* flex-direction: column; */
              justify-content: center;

              a {
                width: 130px;
                height: 40px;
                line-height: 40px;
                margin-right: 20px;
              }

              .btn-line {
                font-size: 14px;
              }
            }
          }
        }
      }

      .container-security {
        padding: 20px 0;

        ul {
          li {
            span {
              font-size: 12px;
              margin-left: 0;
              display: block;
            }

            i {
              font-size: 38px;
            }
          }
        }
      }

      .container-detail-tabnav {
        font-size: 15px;
        height: 44px !important;
        line-height: 44px !important;

        a {
          height: 44px !important;
          padding: 0 12px;
        }
      }

      .container-box {
        .title {
          font-size: 20px;
          padding-left: 12px;
        }

        .box {
          .box-left, .box-right {
            width: 90%;
            padding: 0 5%;

            ul {
              padding: 0 !important;
            }
          }

          .box-info {
            font-size: 13px;
            line-height: 22px;
            padding: 10px 20px;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/subpages/SubSaleCar.vue